module.exports = __webpack_public_path__ + "media/promo/panasonic/images/roll-fc0abb83eedf95eefd6b71ca36c4ae27.png";